export default "__VITE_ASSET__MUCjVR2Z__"